// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket {
    width: 300px;
    border-radius: 10px;
    margin: 50px;
    background: #f8ece4;
    overflow: hidden;
    box-shadow: none !important;
    height: 388.1px;
  }
  .ticket .card-header {
    height: 70px;
    border: 2px solid #a88053;
    border-bottom: 2px dotted #a88053;
    border-radius: 10px 10px 0 0;
    position: relative;
  }
  .ticket .card-header:before, .ticket .card-header:after {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    background: #f8ece4;
    border-radius: 100%;
    bottom: -12px;
    border: 2px solid #a88053;
    box-sizing: border-box;
  }
  .ticket .card-header:before { 
    left: -13px;
  }
  .ticket .card-header:after {
    right: -13px;
  }
  .ticket .card-body {
    height: 200px;
    border: 2px solid #a88053;
    border-top: none;
    border-radius: 0 0 10px 10px;
    padding: 0;
  }
  .ticket .row{
    border:solid 2px #a88053;
  }
  .seats-filled{
    border-bottom:solid 2px #a88053 ;
  }
  .book-btn{
    border-radius: 0px 0px 10px 10px;
    background-color: #2d3248 !important;
  }
  .inner-section{
    border-left:solid 2px #a88053;
  }
  .inner-section p{
    margin: 0px;
  }
  .camps-section{
    background-color:#f8ece4 ;
  }
  .about-jap{
    background-color: #2d3248 !important;
  }

  /* Photo gallery */
  .photo-gallery {
    color:#313437;
    background-color:#f8ece4 ;
  }
  
  .photo-gallery p {
    color:#7d8285;
  }
  
  .photo-gallery h2 {
    font-weight:bold;
    margin-bottom:40px;
    padding-top:40px;
    color:inherit;
    font-size:inherit;
  }
  
  @media (max-width:767px) {
    .photo-gallery h2 {
      margin-bottom:25px;
      padding-top:25px;
      font-size:24px;
    }
  }
  
  .photo-gallery .intro {
    font-size:16px;
    max-width:500px;
    margin:0 auto 40px;
  }
  
  .photo-gallery .intro p {
    margin-bottom:0;
  }
  
  .photo-gallery .photos {
    padding-bottom:20px;
  }
  
  .photo-gallery .item {
    padding-bottom:30px;
  }
  .off-white{
    color: #F3E8E0 !important;
  }
  h3.off-white{
    font-size: 1.4rem;
    line-height: 1.6em;
  }
  
  .testimonials-text{
    text-transform: uppercase !important;
  }

  .more-pics{
    transition: max-height 0.9s ease; /* Smooth transition effect */

  }
  .fade-in {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }
  
  .fade-in.loaded {
    opacity: 1;
  }`, "",{"version":3,"sources":["webpack://./src/pages/spectator/Tickets.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,oCAAoC;EACtC;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,oCAAoC;EACtC;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE;MACE,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;IAChB;EACF;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,gCAAgC,EAAE,6BAA6B;;EAEjE;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;;EAEA;IACE,UAAU;EACZ","sourcesContent":[".ticket {\n    width: 300px;\n    border-radius: 10px;\n    margin: 50px;\n    background: #f8ece4;\n    overflow: hidden;\n    box-shadow: none !important;\n    height: 388.1px;\n  }\n  .ticket .card-header {\n    height: 70px;\n    border: 2px solid #a88053;\n    border-bottom: 2px dotted #a88053;\n    border-radius: 10px 10px 0 0;\n    position: relative;\n  }\n  .ticket .card-header:before, .ticket .card-header:after {\n    content: '';\n    position: absolute;\n    width: 24px;\n    height: 24px;\n    background: #f8ece4;\n    border-radius: 100%;\n    bottom: -12px;\n    border: 2px solid #a88053;\n    box-sizing: border-box;\n  }\n  .ticket .card-header:before { \n    left: -13px;\n  }\n  .ticket .card-header:after {\n    right: -13px;\n  }\n  .ticket .card-body {\n    height: 200px;\n    border: 2px solid #a88053;\n    border-top: none;\n    border-radius: 0 0 10px 10px;\n    padding: 0;\n  }\n  .ticket .row{\n    border:solid 2px #a88053;\n  }\n  .seats-filled{\n    border-bottom:solid 2px #a88053 ;\n  }\n  .book-btn{\n    border-radius: 0px 0px 10px 10px;\n    background-color: #2d3248 !important;\n  }\n  .inner-section{\n    border-left:solid 2px #a88053;\n  }\n  .inner-section p{\n    margin: 0px;\n  }\n  .camps-section{\n    background-color:#f8ece4 ;\n  }\n  .about-jap{\n    background-color: #2d3248 !important;\n  }\n\n  /* Photo gallery */\n  .photo-gallery {\n    color:#313437;\n    background-color:#f8ece4 ;\n  }\n  \n  .photo-gallery p {\n    color:#7d8285;\n  }\n  \n  .photo-gallery h2 {\n    font-weight:bold;\n    margin-bottom:40px;\n    padding-top:40px;\n    color:inherit;\n    font-size:inherit;\n  }\n  \n  @media (max-width:767px) {\n    .photo-gallery h2 {\n      margin-bottom:25px;\n      padding-top:25px;\n      font-size:24px;\n    }\n  }\n  \n  .photo-gallery .intro {\n    font-size:16px;\n    max-width:500px;\n    margin:0 auto 40px;\n  }\n  \n  .photo-gallery .intro p {\n    margin-bottom:0;\n  }\n  \n  .photo-gallery .photos {\n    padding-bottom:20px;\n  }\n  \n  .photo-gallery .item {\n    padding-bottom:30px;\n  }\n  .off-white{\n    color: #F3E8E0 !important;\n  }\n  h3.off-white{\n    font-size: 1.4rem;\n    line-height: 1.6em;\n  }\n  \n  .testimonials-text{\n    text-transform: uppercase !important;\n  }\n\n  .more-pics{\n    transition: max-height 0.9s ease; /* Smooth transition effect */\n\n  }\n  .fade-in {\n    opacity: 0;\n    transition: opacity 0.5s ease-in-out;\n  }\n  \n  .fade-in.loaded {\n    opacity: 1;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
